module.exports = __webpack_public_path__ + "static/media/mobileScreenshot08.b24794b6.jpg";